export const PreFilledTreeName = 'preFilledTreeComponent';
export const MyOwnTransfersTreeName = 'myOwnTransfersTreeComponent';
export const TasksTreeName = 'TasksTreeComponent';
export const OtherInboxesTreeName = 'otherInboxesTreeComponent';
